module.exports = __webpack_public_path__ + "img/40447706.1a71ab39.png";